angular.module("avant.googleTagManager", []);

require('./googleTagManagerService.coffee');
